import {Label as label} from "@progress/kendo-react-labels";
import React from "react";

export default function FlintLabel({children, htmlFor, className = ''}: labelProps) {
    return <label className={className} htmlFor={htmlFor}>
        {children}
    </label>
}

interface labelProps {
    children: React.ReactNode;
    className?: string;
    htmlFor?: string | undefined;
}
